import _ from 'underscore';

import { cssClass } from '../../style';
import { PermissionsGridStyles } from './PermissionsGridStyle';

export namespace AddNewPermissionStyles {
  export const addNewPermissionCssPrefix = 'AddNewPermission';
  export const buttonContainer = 'button-container';
  export const ButtonTopMargin = 12;

  export type AddNewPermissionContainerStyleArgs = {
    /** number of temporarily added rows when editing/adding a permission rule */
    numAddedRows: number;
    /** whether or not the grantee search popup is visible */
    searching: boolean;
  };

  export let memoizedButtonContainer = _.memoize(ButtonContainer, (args) => { return JSON.stringify(args); });
  export function ButtonContainer(args: AddNewPermissionContainerStyleArgs): string {
    let marginTop = ButtonTopMargin;
    // if extra rows were added to the permissions grid, a negative margin needs to be added to the AddNewPermission button
    // so that it stays in *roughly* the same place before and after editing a permission rule;
    // since the grantee search popup is not actually an overlay, we need to be extra careful with leaving enough space
    // so that it doesn't overlap with positioned elements (e.g. the effective permissions search box) which would paint over.
    if (args.searching) {
      marginTop -= PermissionsGridStyles.GranteeSearchFieldPopupHeight;
    } else if (args.numAddedRows) {
      marginTop -= PermissionsGridStyles.RowHeight * args.numAddedRows;
    }
    return cssClass(addNewPermissionCssPrefix, buttonContainer, {
      marginTop: `${marginTop}px`,
    });
  }

  export const ButtonContent = cssClass(addNewPermissionCssPrefix, 'button-content', {
    alignItems: 'center',
    display: 'inline-flex',
    verticalAlign: 'middle',
  });
}
